import store from '@/store'

const baseURLRep = process.env.BASE_API

/**
 * 拦截请求并与vuex loading 绑定
 * 恩，看起来比直接用axios interceptors 方便一些
 *
 * 同时也做sentry api error log
 *
 * config 参数为：
 * vuexLoading = false，可以禁用某个请求的vuex loading
 * @param service
 * @return {*}
 */
export default function loadingIntercept(service) {
  service.interceptors.request.use(config => {
    const api = config.url.replace(baseURLRep, '').split('?')[0]
    config.vuexLoading !== false && store.commit('api/START_LOADING', api)
    return config
  })

  service.interceptors.response.use(response => {
    const api = response.config.url.replace(baseURLRep, '').split('?')[0]
    response.config.vuexLoading !== false && store.commit('api/STOP_LOADING', api)
    return response
  }, errorResponse => {
    const api = errorResponse.config.url.replace(baseURLRep, '').split('?')[0]
    errorResponse.config.vuexLoading !== false && store.commit('api/STOP_LOADING', api)
    return Promise.reject(errorResponse)
  })

  return service
}



// WEBPACK FOOTER //
// ./src/utils/axios-interceptor/loading-vuex.js